import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferCalculateQuery, OfferCalculateVo, OfferGameServiceCalculateQuery } from './type';

/**
 * 上传/修改数字商品offer时，根据输入的价格计算卖价及排名
  GET /product/offerManage/VirtualCalculateData
  接口ID：263628571
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628571
 */
export const getOfferCalculateData = (params: OfferCalculateQuery): AxiosPromise<OfferCalculateVo> => {
  return request({
    url: '/product/offerManage/VirtualCalculateData',
    method: 'get',
    params
  });
};

/**
 * 上传/修改game service商品offer时，根据输入的价格计算卖价及排名
  GET /product/offerManage/gameServiceCalculateData
  接口ID：263628570
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628570
 */
export const getOfferGameServiceCalculateData = (data: OfferGameServiceCalculateQuery): AxiosPromise<OfferCalculateVo> => {
  return request({
    url: '/product/offerManage/gameServiceCalculateData',
    method: 'post',
    data
  });
};
